import React from 'react';
import ReactDOM from 'react-dom';
import { makeAppRoot } from './index-helper';
import './index.scss';

const appRoot = makeAppRoot();

ReactDOM.render(
  appRoot,
  document.getElementById('app')
);

module.hot && module.hot.accept();
